var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["AED"] = "AED";
    CurrencyCode["RON"] = "RON";
})(CurrencyCode || (CurrencyCode = {}));
var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["EUR"] = "\u20AC";
    CurrencySymbol["CHF"] = "CHF";
    CurrencySymbol["GBP"] = "\u00A3";
    CurrencySymbol["PLN"] = "z\u0142";
    CurrencySymbol["AED"] = "AED";
    CurrencySymbol["RON"] = "lei";
})(CurrencySymbol || (CurrencySymbol = {}));
const CURRENCY_SYMBOLS = {
    [CurrencyCode.EUR]: CurrencySymbol.EUR,
    [CurrencyCode.GBP]: CurrencySymbol.GBP,
    [CurrencyCode.CHF]: CurrencySymbol.CHF,
    [CurrencyCode.RON]: CurrencySymbol.RON,
    [CurrencyCode.PLN]: CurrencySymbol.PLN,
    [CurrencyCode.AED]: CurrencySymbol.AED,
};

export { CurrencyCode as C, CurrencySymbol as a, CURRENCY_SYMBOLS as b };
//# sourceMappingURL=currency-_kacFJHO.js.map
